import { createReducer } from '@reduxjs/toolkit';
import callToggle from '../actions/callToggle';

const initialState = {
  visible: false,
  item: null,
  isCall: true,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(callToggle, (state, action) => action.payload);
});
